import * as Sentry from '@sentry/nuxt'

const runtimeConfig = useRuntimeConfig()

if (
  runtimeConfig.public.client === 'cab' &&
  runtimeConfig.public.stage === 'prod' &&
  process.env.NODE_ENV === 'production'
) {
  Sentry.init({
    // If set up, you can use your runtime config here
    dsn: runtimeConfig.public.sentry.dsn,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: parseFloat(
      runtimeConfig.public.sentry.replaysSessionSampleRate
    ),

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: parseFloat(
      runtimeConfig.public.sentry.replaysOnErrorSampleRate
    ),

    // If you don't want to use Session Replay, just remove the line below:
    integrations: [
      Sentry.replayIntegration({
        networkCaptureBodies: false,
        blockAllMedia: false,
        unmask: ['button', '.formkit-label', '.sentry-unmask'],
      }),
    ],

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    // we don't want to send normal errors yet as the error quota is to low for now
    sampleRate: parseFloat(runtimeConfig.public.sentry.sampleRate),
  })
}
